import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';



@Component({
    selector: 'app-drake-profile',
    templateUrl: './drake-profile.component.html',
    styleUrls: ['./drake-profile.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class DrakeProfileComponent implements OnInit {
    constructor(private router: Router) { }

    ngOnInit(): void {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                const userId = userObj.id;
                if (userId) {
                    this.router.navigateByUrl(`/d/USERS/f/${userId}/t/PROFILE`, { skipLocationChange: true });
                } else {
                    console.error('User ID not found in local storage');
                }
            } catch (error) {
                console.error('Error parsing user JSON:', error);
            }
        } else {
            console.error('User not found in local storage');
        }
    }
}
